import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=36c7b5a0"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"
import style1 from "./AuditLogs.vue?vue&type=style&index=1&id=36c7b5a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports